import { useMutation } from '@tanstack/react-query';
import { SetPasswordParams, setPassword } from '@uplift/api';


export const useSetPasswordMutation = () => {
  return useMutation<undefined, Error, SetPasswordParams>({
    mutationFn: async (args: SetPasswordParams) => {
      const response = await setPassword(args);

      if ('error' in response) {
        throw new Error(response.error);
      }
    },
  });
};
